import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-checklist-edit-btn-change-position',
    templateUrl: './btn-change-position.component.html',
    styleUrls: ['./btn-change-position.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class ChecklistEditBtnChangePositionComponent {
    @Input() disabled: boolean;
    @Input() position: number;
    @Input() minPosition: number = 0;
    @Input() maxPosition: number;
    @Input() title: string;

    @Output() onMoveUp = new EventEmitter();
    @Output() onMoveDown = new EventEmitter();

    constructor() {}

    isMoveUpDisabled() {
        return this.position === this.minPosition || this.disabled;
    }

    isMoveDownDisabled() {
        return this.position === this.maxPosition || this.disabled;
    }

    _moveUpClick() {
        this.onMoveUp.emit();
    }

    _moveDownClick() {
        this.onMoveDown.emit();
    }
}
